import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import _ from "lodash";
import axios from "axios";
import MustacheHelper from "../helpers/mustache";
import TreeOption from "./tree-option";

var Tree = /*#__PURE__*/function () {
  function Tree(remoteData, ref) {
    this.references = this.getSortedRemoteData(remoteData);
    this.options = [];
    this.ref = ref;
  }

  var _proto = Tree.prototype;

  _proto.getSortedRemoteData = function getSortedRemoteData(datas) {
    return datas.sort(function (left, right) {
      return _.get(left, "parent") - _.get(right, "parent");
    });
  };

  _proto.getChildOptions = /*#__PURE__*/function () {
    var _getChildOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(option) {
      var _this$options, levelZeroOption, response, responseData, options, treeOptions, _this$options2, parentOption, parentValue, parentTreeOption, currentDepth, selectedReference, parentValues, derivedUrl, _options, isEnd, _treeOptions;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!_.isEmpty(this.references) && !option)) {
                _context.next = 13;
                break;
              }

              levelZeroOption = this.references[0];
              _context.next = 4;
              return axios.get(levelZeroOption.url);

            case 4:
              response = _context.sent;
              responseData = response.data;
              _context.next = 8;
              return this.getOptionsFromResponseData(levelZeroOption, responseData, option);

            case 8:
              options = _context.sent;

              if (option) {
                option.children = _.map(options, function (o) {
                  return o.value;
                });
              }

              treeOptions = _.map(options, function (o) {
                return new TreeOption(o);
              });

              (_this$options = this.options).push.apply(_this$options, treeOptions);

              return _context.abrupt("return", options);

            case 13:
              if (!(!_.isEmpty(this.references) && option)) {
                _context.next = 36;
                break;
              }

              parentOption = option;
              parentValue = parentOption.value;
              parentTreeOption = _.find(this.options, function (o) {
                return o.value === parentValue;
              });

              if (parentTreeOption) {
                _context.next = 20;
                break;
              }

              option.children = [];
              return _context.abrupt("return", []);

            case 20:
              currentDepth = parentOption.depth + 1;
              selectedReference = this.references[currentDepth];

              if (selectedReference) {
                _context.next = 25;
                break;
              }

              parentOption.isEnd = true;
              return _context.abrupt("return", []);

            case 25:
              parentValues = parentTreeOption.getParentValues();
              derivedUrl = MustacheHelper.getCompiledText(selectedReference.url, {
                parent: parentValues
              });
              _context.next = 29;
              return this.getDerivedOptions(derivedUrl, selectedReference, parentOption);

            case 29:
              _options = _context.sent;
              isEnd = currentDepth + 1 === this.references.length;

              if (parentOption) {
                parentOption.children = _.map(_options, function (o) {
                  return o.value;
                });
              }

              _treeOptions = _.map(_options, function (o) {
                return new TreeOption(o, isEnd).withParent(parentTreeOption);
              });
              parentTreeOption.withChildren(_treeOptions);

              (_this$options2 = this.options).push.apply(_this$options2, _treeOptions);

              return _context.abrupt("return", _treeOptions);

            case 36:
              return _context.abrupt("return", []);

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getChildOptions(_x) {
      return _getChildOptions.apply(this, arguments);
    }

    return getChildOptions;
  }();

  _proto.isParentInLastDepth = function isParentInLastDepth(parentOption) {
    if (!parentOption) {
      return false;
    }

    var maxDepth = this.references.length - 1;
    return _.get(parentOption, "depth", 0) + 1 >= maxDepth;
  };

  _proto.getDerivedOptions = /*#__PURE__*/function () {
    var _getDerivedOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(derivedUrl, selectedReference, selectedOption) {
      var response, responseData, options;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return axios.get(derivedUrl);

            case 3:
              response = _context2.sent;
              responseData = response.data;
              options = this.getOptionsFromResponseData(selectedReference, responseData, selectedOption);
              return _context2.abrupt("return", options);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", []);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 9]]);
    }));

    function getDerivedOptions(_x2, _x3, _x4) {
      return _getDerivedOptions.apply(this, arguments);
    }

    return getDerivedOptions;
  }();

  _proto.getDerivedUrl = function getDerivedUrl(url, parentValue) {
    var derivedUrl = _.replace(url, ":id", parentValue);

    return derivedUrl;
  };

  _proto.getOptionsFromResponseData = function getOptionsFromResponseData(selectedReference, responseData, parent) {
    var records = _.get(responseData, selectedReference.record.join("."), []);

    var isParentInLastDepth = this.isParentInLastDepth(parent);
    return _.map(records, function (record) {
      var label = _.get(record, selectedReference.label.join("."));

      var value = _.get(record, selectedReference.value.join("."));

      return {
        label: label,
        id: record.id,
        value: value,
        children: isParentInLastDepth ? [] : [""],
        parent: parent ? parent.value : null,
        depth: parent ? parent.depth + 1 : 0
      };
    });
  };

  return Tree;
}();

export default Tree;